import React from 'react'

export default function InvalidRouteErrorPage() {
    return (
        <main style={{ padding: "1rem", color: "grey" }}>
            <h1>There's nothing here!</h1>
        </main>
    )
}
